(() => {
  'use strict';
  const serviceNames = {
    antibody: 'Custom Antibody Service',
    protein: 'Custom Protein Services',
    elisa: 'Custom ELISA Development',
    pcr: 'Custom PCR / qPCR Assay Development',
    multiplex: 'Multiplex Assay Development',
    sequence: 'Other Custom Reagents'
  };
  const aliases = { antibody: 'antibody', antibodies: 'antibody', protein: 'protein', proteins: 'protein', elisa: 'elisa', pcr: 'pcr', qpcr: 'pcr', multiplex: 'multiplex', reagents: 'sequence', sequence: 'sequence', peptide: 'sequence' };
  function openTarget(target) {
    let ancestor = target.closest('details');
    while (ancestor) {
      ancestor.open = true;
      ancestor = ancestor.parentElement?.closest('details');
    }
  }
  function selectService(root, type) {
    const select = root.querySelector('select[name="contact[Custom service]"]');
    const target = root.querySelector('[id^="abm-custom-' + type + '-"]');
    if (!select || !target || !serviceNames[type]) return null;
    select.value = serviceNames[type];
    openTarget(target);
    return target;
  }
  function bind(root) {
    if (root.dataset.serviceBound) return;
    root.dataset.serviceBound = 'true';
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      if (link.dataset.enquiryModule) {
        const input = root.querySelector('[data-service-module]');
        if (input) input.value = link.dataset.enquiryModule;
      }
      if (root.matches('.abm-custom')) {
        const type = Object.keys(serviceNames).find(key => target.id.startsWith('abm-custom-' + key + '-'));
        if (type) selectService(root, type);
      }
      openTarget(target);
      target.scrollIntoView({block: 'start', behavior: 'auto'});
      history.replaceState(null, '', link.hash);
    });
    const select = root.querySelector('select[name="contact[Custom service]"]');
    select?.addEventListener('change', () => {
      const type = Object.keys(serviceNames).find(key => serviceNames[key] === select.value);
      if (type) selectService(root, type);
    });
  }
  function applyHash() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    if (!id) return;
    let target = document.getElementById(id);
    if (!target && aliases[id]) {
      const root = document.querySelector('.abm-custom');
      if (root) target = selectService(root, aliases[id]);
    }
    if (target) {
      openTarget(target);
      target.scrollIntoView({block:'start', behavior:'auto'});
    }
  }
  function init(container = document) {
    container.querySelectorAll('[data-service-page],.abm-custom').forEach(bind);
    applyHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  window.addEventListener('hashchange', applyHash);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
